const TermsAndConditions = () => {
  return (
    <section className="bg-[#fff8f2] text-[rgb(106,108,168)] py-10">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-screen-xl">
        <div>
          <h2 className="text-center text-3xl sm:text-4xl text-black font-bold mb-6">Terms and Conditions</h2>
          <div className="space-y-6 text-justify">
            <p className="font-bold text-[#6a6a8e]">Welcome to Versai Tech Solutions!</p>
            <p>
              These terms and conditions outline the rules and regulations for the use of the Versai Tech Solutions website, accessible at versaitech.com.
            </p>
            <p>
              By accessing this website, we assume you agree to comply with these terms and conditions. If you do not agree to all the terms and conditions stated here, please discontinue the use of our website.
            </p>
            <p>
              The following terminology applies to these Terms and Conditions, Privacy Policy, and any or all Agreements: "Client", "You", and "Your" refers to the person using our website. "The Company", "We", "Our", and "Us" refers to Versai Tech Solutions. "Party", "Parties", or "Us" refers to both the Client and ourselves.
            </p>
          </div>

          <div className="mt-8 space-y-6 text-justify">
            <div>
              <h3 className="font-bold">1. General</h3>
              <p className="ml-5">
                By using our website, you agree to follow these Terms of Use. We reserve the right to modify these terms at any time, so please review this page periodically.
              </p>
            </div>

            <div>
              <h3 className="font-bold">2. Corrections and Updates</h3>
              <p className="ml-5">
              
                The content on this website may contain typographical errors, inaccuracies, or outdated information. We do not guarantee that the content will always be accurate or up-to-date.
              </p>
            </div>

            <div>
              <h3 className="font-bold">3. Taxes</h3>
              <p className="ml-5">

                Any taxes arising from sales or services provided through our platform are the sole responsibility of the seller.
              </p>
            </div>

            <div>
              <h3 className="font-bold">4. Return Policy</h3>
              <p className="ml-5">

                Due to the nature of our products and services, returns and exchanges are not permitted unless explicitly stated otherwise.
              </p>
            </div>

            <div>
              <h3 className="font-bold">5. Order Cancellations</h3>
              <p className="ml-5">

                You may cancel your order as long as it has not yet been processed or shipped. Once processed, orders cannot be canceled.
              </p>
            </div>

            <div>
              <h3 className="font-bold">6. Product Availability</h3>
              <p className="ml-5">

                While we strive to maintain up-to-date information on product availability, we cannot guarantee that products listed on the site will always be in stock.
              </p>
            </div>

            <div>
              <h3 className="font-bold">7. Shipping & Delivery</h3>
              <p className="ml-5">

                Shipping timelines vary based on your location and the nature of the product ordered. Please refer to our shipping policy for detailed information.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TermsAndConditions;
